// Lazy load function
const lazyLoad = (path) => () => import(/* webpackChunkName: "[request]" */ `@/views/roam/${path}.vue`);

export default [
    {
        path: "/roam-despatch-order",
        name: "roam-despatch-order-list",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "RoamPicking",
        },
        components: {
            content: lazyLoad('sales/roam-despatch-order-list'),
        },
    },

    {
        path: "/roam-despatch-order/review/:id*",
        name: "roam-despatch-order-review",
        meta: { requiresAuth: true, applicationFeatureCode: "RoamPicking" },
        components: {
            content: lazyLoad('sales/roam-despatch-order'),
        },
    },
    {
        path: "/roam-despatch-order/edit/:id*",
        name: "roam-despatch-order-edit",
        meta: { requiresAuth: true, applicationFeatureCode: "RoamPicking" },
        components: {
            content: lazyLoad('sales/roam-despatch-order'),
        },
    },

    {
        path: "/roam-bin-movement",
        name: "roam-bin-movement-list",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "RoamBinMovement",
        },
        components: {
            content: lazyLoad('bin/roam-bin-movement-list'),
        },
    },
    {
        path: "/roam-bin-movement/edit/:id",
        name: "roam-bin-movement",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "RoamBinMovement",
        },
        components: {
            content: lazyLoad('bin/roam-bin-movement'),
        },
    },

    {
        path: "/roam-product",
        name: "roam-product-list",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "RoamProduct",
        },
        components: {
            content: lazyLoad('products/roam-product-list'),
        },
    },
    {
        path: "/roam-product/create/:id",
        name: "roam-product",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "RoamProduct",
        },
        components: {
            content: lazyLoad('products/roam-product'),
        },
    },
]; 